export enum ÉQUIPE_RESPONSABLE {
  FORMATEUR = 'Service accompagnement des formateurs',
  SCIENCES_ET_CULTURE = 'Pôle Sciences & Culture',
  TRANSVERSE = 'Pôle multi-compétences',
  COMPAGNONNIQUE = 'Pôle transmission',
}
